import Vue from 'vue'
import Vuex from 'vuex'

import alerts from './modules/alerts'
import app from './modules/app'
import audio from './modules/audio'
import buildings from './modules/data/buildings'
import color from './modules/color'
import floorplan from './modules/floorplan'
import fullscreen from './modules/fullscreen'
import information from './modules/information'
import krpano from './modules/krpano'
import location from './modules/location'
import markerInfo from './modules/marker-info'
import markers from './modules/data/markers'
import mobileMenu from './modules/mobile-menu'
import panoramas from './modules/data/panoramas'
import panoramasList from './modules/panoramas-list'
import popup from './modules/popup'
import property from './modules/data/property'
import share from './modules/share'
import profile from './modules/profile'
import progress from './modules/progress'
import promotion from './modules/promotion'
import social from './modules/data/social'
import ui from './modules/ui'
import user from './modules/data/user'
import auth from './modules/auth'
import visitor from './modules/data/visitor'
import vrmode from './modules/vrmode'
import vrlounge from './modules/vrlounge'
import overlay from './modules/overlay'
import tourRing from './modules/tour-ring'
import search from './modules/search'
import conference from './modules/conference'
import pilot from './modules/pilot'
import favorites from './modules/favorites'
import joor from './modules/joor'
import instantMessaging from './modules/instant-messaging'
import visitorHistory from './modules/visitorHistory'
import arview from './modules/arview'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    alerts,
    app,
    audio,
    buildings,
    color,
    floorplan,
    fullscreen,
    information,
    krpano,
    location,
    markerInfo,
    markers,
    mobileMenu,
    panoramas,
    panoramasList,
    popup,
    property,
    share,
    profile,
    progress,
    promotion,
    social,
    ui,
    user,
    auth,
    visitor,
    vrmode,
    vrlounge,
    overlay,
    tourRing,
    search,
    conference,
    pilot,
    favorites,
    joor,
    instantMessaging,
    visitorHistory,
    arview
  },
  strict: process.env.NODE_ENV === 'dev'
})

export default store
